// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__BIGtO","Active":"Button_Active__En29q"};